import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const AltRoute = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.9167 45.8334V35.4167C22.9167 33.4723 22.6215 32.0313 22.0312 31.0938C21.441 30.1563 20.6597 29.2362 19.6875 28.3334L22.6562 25.3647C23.0729 25.7466 23.4722 26.1546 23.8542 26.5886C24.2361 27.0227 24.6181 27.4827 25 27.9688C25.4861 27.3091 25.9809 26.7275 26.4844 26.224C26.9878 25.7206 27.5 25.2258 28.0208 24.7397C29.3403 23.5244 30.5382 22.1181 31.6146 20.5209C32.691 18.9237 33.2639 16.1286 33.3333 12.1355L30.0521 15.4167L27.0833 12.5001L35.4167 4.16675L43.75 12.5001L40.8333 15.4167L37.5 12.1355C37.4306 17.1008 36.6667 20.6338 35.2083 22.7345C33.75 24.8352 32.2917 26.5452 30.8333 27.8647C29.7222 28.8716 28.8194 29.8525 28.125 30.8074C27.4306 31.7622 27.0833 33.2987 27.0833 35.4167V45.8334H22.9167ZM12.9167 17.0313C12.7778 16.3369 12.6823 15.573 12.6302 14.7397C12.5781 13.9063 12.5347 13.0383 12.5 12.1355L9.16667 15.4167L6.25 12.5001L14.5833 4.16675L22.9167 12.5001L19.9479 15.4167L16.6667 12.1876C16.6667 12.9167 16.7014 13.6025 16.7708 14.2449C16.8403 14.8872 16.9097 15.4862 16.9792 16.0417L12.9167 17.0313ZM17.3958 26.198C16.7014 25.4688 16.033 24.6181 15.3906 23.6459C14.7483 22.6737 14.184 21.4758 13.6979 20.0522L17.7083 19.0626C18.0556 20.0001 18.4549 20.7987 18.9062 21.4584C19.3576 22.1181 19.8438 22.7084 20.3646 23.2292L17.3958 26.198Z"
        fill={color}
      />
    </svg>
  )
}
